import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DIAM_API_PATH, revokeInvitation } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useRevokeInvitation() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitationId: string) => {
      const idToken = await getIdToken();
      return revokeInvitation(apiUrl, idToken, invitationId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['diam', 'invitations'] });
      queryClient.invalidateQueries({
        queryKey: ['diam', 'invitations', 'pending-count'],
      });
    },
  });
}
